import { formatBatchSelectLabel } from './batchLabels';

/**
 * Map a staging/form batch hint (id or name) onto a catalog batch id.
 * @param {object[]} batches
 * @param {string|number|null|undefined} hint
 * @returns {string} catalog batch id, or ''
 */
export function matchCatalogBatchId(batches, hint) {
  const list = Array.isArray(batches) ? batches : [];
  const text = String(hint ?? '').trim();
  if (!text || !list.length) return '';

  const byId = list.find((b) => String(b.id) === text);
  if (byId) return String(byId.id);

  const lower = text.toLowerCase();
  const exactName = list.filter(
    (b) => String(b.batchName || '').trim().toLowerCase() === lower
  );
  if (exactName.length === 1) return String(exactName[0].id);

  const exactLabel = list.filter(
    (b) => formatBatchSelectLabel(b).toLowerCase() === lower
  );
  if (exactLabel.length === 1) return String(exactLabel[0].id);

  const nameContains = list.filter((b) => {
    const name = String(b.batchName || '').trim().toLowerCase();
    return name && (name.includes(lower) || lower.includes(name));
  });
  if (nameContains.length === 1) return String(nameContains[0].id);

  return '';
}
